export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_AS = 'LOGIN_AS';
export const CHECK_AUTH = 'CHECK_AUTH';
export const LOGGED_OUT_AS = 'LOGGED_OUT_AS';
export const RESET_PASSWORD = 'RESET_PASSWORD';